import { useMostPopularCertificates } from '../../../components/MostPopularCertificates/MostPopularCertificates';
import { useIsPaidAccount } from '../../../hooks/productsHooks';
import { useHasGate } from '../../accounts';
import { useInternalContentItems } from '../../internalContent/internalContentQueries';
import { useMyLearningCardModels } from '../../myLearning';
import { usePersonaRecommendations } from '../../persona/hooks';
const RECENT_THRESHOLD = 7 * 24 * 60 * 60 * 1000; // one week

export const usePersonalizedHomepageOrder = () => {
  const [isPaidAccount, isPaidAccountLoading] = useIsPaidAccount();
  const {
    myLearningCardModels,
    myLearningCardModelsLoading
  } = useMyLearningCardModels({
    offset: {
      cursor: 0
    },
    pageLength: 10,
    contentTypes: ['TRACK', 'LEARNING_PATH', 'PLAYLIST', 'LESSON']
  });
  const {
    hasGate: hasTrainerContentGate
  } = useHasGate('Academy:TrainerContent');
  const {
    internalContentItems,
    internalContentItemsLoading
  } = useInternalContentItems({
    pageLength: 1,
    skip: !hasTrainerContentGate
  });
  const {
    recommendations: personaRecommendations,
    isLoading: personaRecommendationsLoading
  } = usePersonaRecommendations(4);
  const {
    certificates,
    certificatesLoading
  } = useMostPopularCertificates();
  const hasRecentProgress = myLearningCardModels === null || myLearningCardModels === void 0 ? void 0 : myLearningCardModels.some(item => {
    var _item$progress, _item$progress2;
    return ((_item$progress = item.progress) === null || _item$progress === void 0 ? void 0 : _item$progress.updatedAt) && ((_item$progress2 = item.progress) === null || _item$progress2 === void 0 ? void 0 : _item$progress2.updatedAt) > new Date().getTime() - RECENT_THRESHOLD;
  });
  const hasAnyProgress = myLearningCardModels === null || myLearningCardModels === void 0 ? void 0 : myLearningCardModels.length;
  const hasInternalContent = hasTrainerContentGate && (internalContentItems === null || internalContentItems === void 0 ? void 0 : internalContentItems.length);
  if (isPaidAccountLoading || myLearningCardModelsLoading || internalContentItemsLoading || personaRecommendationsLoading || certificatesLoading) {
    return {
      loading: true,
      items: []
    };
  }
  if (isPaidAccount) {
    return {
      loading: false,
      items: [hasRecentProgress && 'in-progress', hasInternalContent && 'internal-content', (personaRecommendations === null || personaRecommendations === void 0 ? void 0 : personaRecommendations.length) && 'persona-based-recommendations', 'progress-based-recommendations', (certificates === null || certificates === void 0 ? void 0 : certificates.length) && 'popular-certificates', !hasRecentProgress && hasAnyProgress && 'in-progress'].filter(Boolean)
    };
  }
  return {
    loading: false,
    items: [hasRecentProgress && 'in-progress', hasInternalContent && 'internal-content', (certificates === null || certificates === void 0 ? void 0 : certificates.length) && 'popular-certificates', 'progress-based-recommendations', (personaRecommendations === null || personaRecommendations === void 0 ? void 0 : personaRecommendations.length) && 'persona-based-recommendations', !hasRecentProgress && hasAnyProgress && 'in-progress'].filter(Boolean)
  };
};